export { default as OwnerEditPostFormNews } from './SubformNews'
